import axios from 'axios';
import MainService from './MainService';

export default class StorageService extends MainService {
	constructor() {
		super();
		this.url = `${this.apiUrl}/storage`;
	}

	downloadFile(path) {
  	return axios.get(`${this.url}/download`, {params: { path }, responseType: 'blob'});
	}
}



// WEBPACK FOOTER //
// ./src/service/StorageService.js